import { render, staticRenderFns } from "./cv-content.vue?vue&type=template&id=c7aa021a&"
import script from "./cv-content.vue?vue&type=script&lang=js&"
export * from "./cv-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports